module.exports = __webpack_public_path__ + "static/media/Bloodseeker.320c7508.png";